<template>
  <section class="container">
    <span class="oldId" style="display:none"></span>
    <div class="banner">
      <div class="turnplate">
        <canvas class="item" id="wheelcanvas"></canvas>
        <img class="pointer" src="~assets/images/lottery/but_dianjichoujiang.png" :data-root="canRotate" />
      </div>
      <div class="button" @click="history">
        <img :src="getActivityList.winningRecordPicture" alt="">
      </div>
    </div>
    <div class="text">
      <p class="f10" v-for="(item,index) in getActivityList.prizeExplain" :key="index">{{item}}</p>
    </div>
    <div class="bottom">
      <h1 class="f14">活动规则：</h1>
      <p class="f10" v-for="(item,index) in getActivityList.activityRule" :key="index">{{item}}</p>
    </div>
    <div class="layer" v-show="showPopup" @click="showPopup=false"></div>
    <div class="activity">
      <template v-if="activityStatus == 1002">
        <img src="../assets/images/lottery/1002.png" alt="">
      </template>
      <template v-if="activityStatus == 1003">
        <img src="../assets/images/lottery/1003.png" alt="">
      </template>
        <template v-if="activityStatus == 1005">
        <img src="../assets/images/lottery/1005.png" alt="">
      </template>
      <template v-if="activityStatus == 1006">
        <img src="../assets/images/lottery/1006.png" alt="">
      </template>
    </div>
    <div class="pop-up" v-show="showPopup">
      <h1 class="title_yy">中奖纪录</h1>
      <template v-if="isAwar">
           <div class="content" :class="{flex:prizeList[index] == '谢谢参与'}">
              <h1 class="f44">{{prizeList[index]}}</h1>
              <template v-if="prizeList[index] != '谢谢参与'">
                <p class="desc f16">{{spoilList[index]}}</p>
                <a href="javascript:;" class="button f24" @click="exchange" :class="{'disable':hasExchanged}">
                {{words}}
              </a>
              </template>
              <p class="tip">注：{{awardRemark}}!</p>
            </div>
      </template>
      <template v-else>
        <div class="content_ccc">
           <ul>
             <li>  
                  <span class="jiangx">奖项</span>
                  <span class="jiangp">奖品</span>
                  <span class="">状态</span>
              </li>
             <li v-for="item in tableData" :key="item.id">
               <span class="jiangx">{{item.awardName}}</span>
               <span class="jiangp">{{item.prizeName}}</span>
               <span class="state">
                 <span v-if="item.state === 1">
                   未兑换<img @click="kkkk(item)" src="../assets/images/lottery/button.png" alt="">
                 </span>
                 <span v-else >
                   已兑换
                 </span>
                 </span>
             </li>
           </ul>
         </div> 
         <div class="op" style="text-align: center">
            <el-pagination
              small
              background
              layout="prev, pager, next"
              @current-change="changDate"
              :total="total">
            </el-pagination>
         </div>
      </template>
    </div>
  </section>
</template>
<script>
import Lottery from "@/assets/js/lottery.js";
require("../assets/js/bridge.js");
export default {
  name: "",
  data() {
    return {
      sid: this.$route.query.sid,
      activityId: this.$route.query.activityId,
      getActivityList: "",
      loading: true,
      awardId: "",
      isClick: true,
      tableData: [{ awardName: "" }],
      isAwar: true,
      showPopup: false,
      hasExchanged: false,
      words: "点击兑换",
      canRotate: true,
      activityStatus: 1, //0:未开启,1:进行中,2:已结束
      index: 0,
      level: null,
      prizeListId: [],
      awardTypeId: "",
      awardRemarkList: [],
      awardTypeIdList: [],
      awardRemark: "",
      jiang: {
        studentId: this.$route.query.sid,
        activityId: this.$route.query.activityId,
        pageSize: 10,
        pageNum: 1
      },
      total: 0,
      prizeList: [
        "二等奖",
        "三等奖",
        "二等奖",
        "三等奖",
        "一等奖",
        "三等是奖"
        // "四等奖"
      ],
      colorList: [
        "#fec75c",
        "#ff8584",
        "#fec75c",
        "#ff8584",
        "#fec75c",
        "#ff8584"
      ],
      spoilList: [
        "工业机器人技术专业十三五规划教材",
        "哈工海渡定制便签本一本",
        "工业机器人技术专业十三五规划教材",
        "哈工海渡定制便签本一本",
        "哈工海渡定制移动电源一个",
        "哈工海渡定制便签本一本"
      ]
    };
  },
  created() {
    if (!this.sid || !this.activityId) {
      // this.alert.confirm("您还没登录，是否要登录?").then(action => {
      this.$router.push(`/activity/login?activityId=` + activityId);
      console.log(actions);
      // });
      // this.toast("很抱歉，您的信息不全");
      return false;
    }
    this.setActivity();
    // this.canRotate = false;
    // this.init(0);
    // this.check();
    this.checkChance();
    this.getActivityDetail();
  },
  mounted() {
    // console.log(a);
  },
  computed: {},
  methods: {
    getActivityDetail() {
      this.service.getActivityTurntableDetail(this.activityId).then(res => {
        if (res.success) {
          res.data.activityRule = res.data.activityRule.split("；");
          res.data.prizeExplain = res.data.prizeExplain.split("；");
          this.getActivityList = res.data;
        }
      });
    },
    changDate(val) {
      console.log(val);
      this.jiang.pageNum = val;
      this.history();
    },
    loadMore() {
      this.loading = true;
      setTimeout(() => {
        let last = this.list[this.list.length - 1];
        for (let i = 1; i <= 10; i++) {
          this.list.push(last + i);
        }
        this.loading = false;
      }, 2500);
    },
    checkChance() {
      this.service
        .activityTurntableCheckChance({
          studentId: this.sid,
          activityId: this.activityId
        })
        .then(res => {
          if (res.success) {
            this.canRotate = true;
          } else {
            if (res.code === 1002) {
              this.activityStatus = 1002;
              return false;
            }
            if (res.code === 1003) {
              this.activityStatus = 1003;
              return false;
            }
            if (res.code === 1005) {
              this.activityStatus = 1005;
              return false;
            }
            if (res.code === 1006) {
              this.activityStatus = 1006;
              return false;
            }
            app.alert({
              title: "",
              message: res.message
            });
          }
        });
    },
    check() {
      this.service
        .checkReward({
          studentId: this.sid
        })
        .then(result => {
          if (result.success) {
            // console.log(result);
            // this.canRotate = !result.data.isAttend;
            // this.hasExchanged = result.data.isGet;
            // this.level = result.data.level;
            // this.activityStatus = result.data.state;
            // this.init(this.prizeList.indexOf(result.data.level) + 1);
          } else {
            // this.toast(result.message);
            // this.canRotate = false;
            // this.init(0);
          }
        });
    },
    submit(level) {
      this.service
        .saveReward({
          studentId: this.sid,
          level: level
        })
        .then(result => {});
    },
    kkkk(item) {
      console.log(item.id);
      $(".oldId").html(item.id);
      this.exchange();
    },
    exchange() {
      this.awardId = $(".oldId").html();
      this.service
        .dhReward({
          studentId: this.sid,
          activityId: this.activityId,
          logId: this.awardId
        })
        .then(result => {
          if (result.success) {
            this.hasExchanged = true;
            this.ReceiveAfter();
            this.checkChance();
            this.showPopup = false;
          } else {
            this.toast(result.message);
          }
        });
    },
    /**
     * 查看历史
     * @return {[type]} [description]
     */
    history() {
      this.service.checkHistory(this.jiang).then(res => {
        console.log(res);
        if (res.success) {
          console.log(res);
          this.tableData = res.data;
          this.total = res.total;
        }
      });
      // if (null == this.level || this.canRotate) return;
      // let index = this.prizeList.indexOf(this.level);
      this.showPopup = true;
      this.isAwar = false;
      // this.index = index;
    },
    Receive() {
      if (this.awardTypeId === 0) {
        this.words = "确定";
      }
      if (this.awardTypeId === 1) {
        this.words = "点击兑换";
      }
      if (this.awardTypeId === 2) {
        this.words = "点击兑换";
      }
      if (this.awardTypeId === 3) {
        this.words = "点击领取";
      }
    },
    ReceiveAfter() {
      if (this.awardTypeId === 0) {
        this.words = "确定";
      }
      if (this.awardTypeId === 1) {
        this.words = "已兑换";
        this.toast(`兑换成功`);
      }
      if (this.awardTypeId === 2) {
        this.words = "已兑换";
        this.toast(`兑换成功`);
      }
      if (this.awardTypeId === 3) {
        this.words = "已领取";
        this.toast(`领取成功`);
      }
    },
    init(result) {
      let that = this;
      new Lottery(
        this.prizeList,
        this.colorList,
        result,
        function(item) {
          that.isAwar = true;
          that.showPopup = true;
          that.canRotate = false;
          that.hasExchanged = false;
          // that.isClick = true;
          that.index = item - 1;
          if (item === 0) {
            that.index = 5;
          }
          that.awardId = that.prizeListId[that.index];
          that.awardRemark = that.awardRemarkList[that.index];
          that.awardTypeId = that.awardTypeIdList[that.index];
          that.Receive();
        },
        this.prizeListId,
        {
          studentId: this.sid,
          activityId: this.activityId
        },
        this.isClick
      );
    },
    // activityCheck() {
    //   this.service
    //     .activityTurntableCheck({
    //       studentId: this.sid,
    //       activityId: this.activityId
    //     })
    //     .then(res => {
    //       console.log(res);
    //     });
    // },
    setActivity() {
      this.service
        .getActivityTurntableAwardDetail(this.activityId)
        .then(res => {
          this.prizeList = [];
          this.spoilList = [];
          if (res.success) {
            res.data.forEach(item => {
              this.prizeList.push(item.awardName);
              this.prizeListId.push(item.id);
              this.spoilList.push(item.prizeName);
              this.awardRemarkList.push(item.awardRemark);
              this.awardTypeIdList.push(item.awardTypeId);
            });
            // 1,2,3,4,5,0
            this.init(1);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(~assets/images/lottery/img_bg.png) top no-repeat;
  background-size: contain;
  background-color: #0e8998;
}

.layer {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1000;
}

.activity {
  width: 100%;
  margin: 0 auto;
  position: fixed;
  top: 3.6rem;
  z-index: 1001;
  text-align: center;
  img {
    width: 8.267rem;
  }
}

.pop-up {
  position: fixed;
  z-index: 1001;
  width: 8.667rem;
  height: 8.667rem;
  background: rgba(0, 0, 0, 0.9);
  top: 3.6rem;
  left: 0.67rem;
  padding: 0.267rem;
  box-sizing: border-box;
  .title_yy {
    color: #fff;
  }
  .content {
    border: 1px dashed #fff;
    width: 100%;
    height: 7.433rem;
    text-align: center;
    position: relative;
    margin-top: 0.133rem;
    padding: 0.867rem 0.267rem;
    box-sizing: border-box;
    &.flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h1 {
      color: #ffd800;
    }
    .desc {
      color: #ffd800;
      margin-top: 0.467rem;
    }
    .button {
      display: block;
      width: 5.427rem;
      height: 1.213rem;
      line-height: 1.213rem;
      background: url("../assets/images/lottery/but_duihuan.png") center
        no-repeat;
      background-size: cover;
      color: #010101;
      margin: 0.6rem auto 0;
      &.disable {
        background: url("../assets/images/lottery/but_yiduihuan.png") center
          no-repeat;
        background-size: cover;
        color: #fff;
      }
    }
    .tip {
      color: #fff;
      position: absolute;
      width: 100%;
      bottom: 0.133rem;
      text-align: center;
      font-size: 0.35rem;
    }
  }
}

.banner {
  display: block;
  width: 80%;
  margin: 0.8rem auto 0;
  .turnplate {
    display: block;
    width: 100%;
    position: relative;
    background: url(~assets/images/lottery/img_waihuan2.png) center no-repeat;
    background-size: contain;
    .item {
      width: 100%;
    }
    img.pointer {
      width: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      top: 50%;
      position: absolute;
    }
  }

  .button {
    width: 7.44rem;
    margin: 0.3rem auto 0;
    position: relative;
    z-index: 3;
    img {
      width: 100%;
    }
  }
}

.text {
  width: 8.76rem;
  height: 3.8rem;
  background: url("../assets/images/lottery/img_text_bg.png") center no-repeat;
  background-size: cover;
  position: relative;
  bottom: 0.333rem;
  z-index: 2;
  margin: 0 auto;
  padding-left: 1rem;
  padding-top: 0.667rem;
  p {
    color: #002529;
    margin-bottom: 0.133rem;
    width: 7rem;
  }
}

.bottom {
  width: 100%;
  background: #0e8998;
  color: #fff;
  padding-left: 1.2rem;
  box-sizing: border-box;
  font-style: italic;
  font-weight: bold;
  padding-top: 0.267rem;
  line-height: 0.427rem;
  padding-bottom: 0.667rem;
  p {
    width: 8rem;
  }
}
.content_ccc {
  color: #ffd800;
  border: 1px solid #999;
  padding: 0.2rem;
  ul li {
    margin: 0.12rem 0;
    list-style: none;

    span {
      display: inline-block;
      // margin-left: 20px;
    }
    .jiangx {
      width: 1.6rem;
    }
    .jiangp {
      width: 3.8rem;
    }
    img {
      width: 0.9rem;
      position: relative;
      top: 0.06rem;
      right: -0.06rem;
    }
  }
}
.op {
  width: 100%;
}
</style>
<style>
/* .op > * {
  background: rgba(0, 0, 0, 0) !important;
} */
</style>




// WEBPACK FOOTER //
// Lottery.vue?4c68de6b